@if (form) {

  <div class="flex align-items-center justify-content-center">
    <form class="edit-form gap-4" [formGroup]="form">

      <div class="form-item">
        <p-float-label>
          <input pInputText
                 id="groupId"
                 formControlName="groupId"
                 class="gap-4"
                 maxlength="50"
                 [required]="!id"
                 [disabled]="!!id"
                 [pKeyFilter]="ValidationUtils.ID_PATTERN"
          />
          <label for="groupId" i18n>Group ID</label>
        </p-float-label>
      </div>

      <div class="form-item">
        <p-float-label>
          <input pInputText
                 id="displayName"
                 class="gap-4"
                 formControlName="displayName"
                 maxlength="100"
                 required
                 [pKeyFilter]="ValidationUtils.TITLE_PATTERN"
          />
          <label for="groupId" i18n>Name</label>
        </p-float-label>
      </div>

      <div class="form-item">
        <p-float-label>
          <textarea pInputText
                    id="description"
                    class="gap-4"
                    formControlName="description"
                    maxlength="1000"
                    cols="50" rows="5"
          ></textarea>
          <label for="groupId" i18n>Description</label>
        </p-float-label>
      </div>

      <div class="form-item flex align-items-center gap-4 mb-5">
        <label class="bold" for="locked" i18n>Locked</label>
        <p-toggle-switch id="locked" formControlName="locked" />
      </div>

      <div class="form-buttons form-item-locked flex justify-content-between align-items-center">
        @if (id) {
          <button type="button"
                  class="p-button form-btn warning gap-2 delete"
                  (keydown.enter)="deleteGroup()"
                  (click)="deleteGroup()" i18n>
            Delete
          </button>
        }
        <button type="button"
                class="p-button form-btn gap-2 save"
                (keydown.enter)="save()"
                (click)="save()" i18n>
          Save
        </button>

        <button type="button"
                class="p-button form-btn secondary cancel gap-2"
                (keydown.enter)="cancel()"
                (click)="cancel()" i18n>
          Cancel
        </button>
      </div>

      @if(!editingGroup) {
        @switch (messageType) {
          @case ('FORM_INVALID') {
            <p-message severity="error" closable i18n>There are problems with your submission. Please address the fields highlighted in red</p-message>
          }
          @case ('ERROR_SAVING') {
            <p-message severity="error" closable i18n>An error occurred while saving your changes. Please try again</p-message>
          }
          @case ('CHANGES_SAVED') {
            <p-message severity="success" closable i18n>Your changes have been saved!</p-message>
          }
          @case ('NOT_UNIQUE') {
            <p-message severity="error" closable i18n>A group already exists with that name. Please try another</p-message>
          }
          @case ('IN_USE') {
            <p-message severity="info" closable i18n>This group cannot be deleted while it is assigned to an application, page or user. Please remove uses of this group to continue</p-message>
          }
          @case ('NOT_EXISTS') {
            <p-message severity="error" closable i18n>This group does not exist. It may have been deleted</p-message>
          }
          @case ('DELETION_CANCELLED') {
            <p-message severity="info" closable i18n>Group has not been deleted</p-message>
          }
        }
      }

      <p-confirmDialog></p-confirmDialog>
    </form>
  </div>
}
